"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAlphalendRevenueTokensForDate = fetchAlphalendRevenueTokensForDate;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const getMarkets_js_1 = require("./runQueries/getMarkets.js");
const dailyRevenue_js_1 = require("../analytics/crons/dailyRevenue.js");
const decimal_js_1 = require("decimal.js");
const sentioClient_js_1 = require("./sentioClient.js");
// OLD IMPLEMENTATION - Chunked queries approach
// export async function fetchAlphalendRevenueTokensForDate(
//   dateString: string,
// ): Promise<AlphalendMarketTokenRevenue[]> {
//   // Create 12 chunks of 2 hours each
//   const chunks: Array<{ minTimestamp: number; maxTimestamp: number }> = [];
//   for (let i = 0; i < 12; i++) {
//     const startHour = i * 2;
//     const endHour = (i + 1) * 2;
//     const minDate = new Date(dateString);
//     minDate.setHours(startHour, 0, 0, 0);
//     const maxDate = new Date(dateString);
//     maxDate.setHours(endHour, 0, 0, 0);
//     chunks.push({
//       minTimestamp: minDate.getTime(),
//       maxTimestamp: maxDate.getTime(),
//     });
//   }
//   // Create parallel queries for each chunk
//   const chunkQueries = chunks.map(async (chunk, index) => {
//     const sql = `
//       SELECT
//           date,
//           market_id,
//           SUM(fee) as total_fee
//       FROM (
//           SELECT
//               DATE(fromUnixTimestamp64Milli(timestamp_ms)) as date,
//               JSONExtract(fields, 'event', 'market_id', 'UInt64') AS market_id,
//               JSONExtract(fields, 'event', 'is_native', 'Boolean') as is_native,
//               JSONExtract(fields, 'event', 'market_fee', 'UInt64') as market_fee,
//               JSONExtract(fields, 'event', 'protocol_fee', 'UInt64') as protocol_fee,
//               CASE
//                   WHEN JSONExtract(fields, 'event', 'is_native', 'Boolean') = true
//                   THEN JSONExtract(fields, 'event', 'market_fee', 'UInt64') + JSONExtract(fields, 'event', 'protocol_fee', 'UInt64')
//                   WHEN JSONExtract(fields, 'event', 'is_native', 'Boolean') = false
//                   THEN JSONExtract(fields, 'event', 'protocol_fee', 'UInt64')
//               END as fee
//           FROM sui.events
//           WHERE timestamp_ms >= ${chunk.minTimestamp}
//               AND timestamp_ms < ${chunk.maxTimestamp}
//               AND (type = '0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::events::Event<0xc27cbe69992b31a811b8d5d34996c4a53b3536f60357b1d50abfa1876458c399::market::FeeEarnedEvent_V2>'
//                   OR type = '0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::events::Event<0xc8a5487ce3e5b78644f725f83555e1c65c38f0424a72781ed5de4f0369725c79::market::FeeEarnedEvent_V3>')
//       )
//       GROUP BY date, market_id
//       ORDER BY date DESC, market_id ASC;`;
//     const rows: { date: string; market_id: number; total_fee: number }[] =
//       await executeSentioQuery(sql);
//     return rows;
//   });
//   // Execute chunk queries sequentially with 1-second delay
//   const chunkResults: {
//     date: string;
//     market_id: number;
//     total_fee: number;
//   }[][] = [];
//   for (let i = 0; i < chunkQueries.length; i++) {
//     const result = await chunkQueries[i];
//     chunkResults.push(result);
//     // Add 1-second delay between queries (except for the last one)
//     if (i < chunkQueries.length - 1) {
//       await new Promise((resolve) => setTimeout(resolve, 2000));
//     }
//   }
//   // Aggregate results by market_id (sum fees for same market across chunks)
//   const marketFeeMap = new Map<number, number>();
//   chunkResults.flat().forEach((row) => {
//     const existingFee = marketFeeMap.get(row.market_id) ?? 0;
//     marketFeeMap.set(row.market_id, existingFee + row.total_fee);
//   });
//   // Convert aggregated results to the expected format
//   const alphalendMarkets = await getAllMarkets();
//   const results: AlphalendMarketTokenRevenue[] = [];
//   for (const [marketId, totalFee] of marketFeeMap) {
//     const market = alphalendMarkets.find(
//       (market) => market.marketId === marketId,
//     );
//     if (!market) {
//       throw new Error(`Market not found for id: ${marketId}`);
//     }
//     const coinDecimals = Object.values(coinsList).find(
//       (coinInfo) => coinInfo.type === market.coinType,
//     )?.expo;
//     if (!coinDecimals) {
//       throw new Error(
//         `Coin decimals not found for coin type: ${market.coinType}`,
//       );
//     }
//     results.push({
//       time: getEndOfDayGMT(Date.parse(dateString)),
//       marketCoinType: market.coinType,
//       coinAmount: new Decimal(totalFee).div(10 ** coinDecimals).toString(),
//     });
//   }
//   return results;
// }
// NEW IMPLEMENTATION - Single 24-hour query
async function fetchAlphalendRevenueTokensForDate(dateString) {
    // Calculate 24-hour timestamp range for the given date
    const minDate = new Date(dateString);
    minDate.setHours(0, 0, 0, 0);
    const minTimestamp = minDate.getTime();
    const maxDate = new Date(dateString);
    maxDate.setHours(23, 59, 59, 999);
    const maxTimestamp = maxDate.getTime();
    // Execute single query for the entire 24-hour period
    const sql = `
    SELECT 
        date, 
        market_id,
        SUM(fee) as total_fee
    FROM (
        SELECT 
            DATE(fromUnixTimestamp64Milli(timestamp_ms)) as date,
            JSONExtract(fields, 'event', 'market_id', 'UInt64') AS market_id,
            JSONExtract(fields, 'event', 'is_native', 'Boolean') as is_native, 
            JSONExtract(fields, 'event', 'market_fee', 'UInt64') as market_fee, 
            JSONExtract(fields, 'event', 'protocol_fee', 'UInt64') as protocol_fee,
            CASE 
                WHEN JSONExtract(fields, 'event', 'is_native', 'Boolean') = true 
                THEN JSONExtract(fields, 'event', 'market_fee', 'UInt64') + JSONExtract(fields, 'event', 'protocol_fee', 'UInt64')
                WHEN JSONExtract(fields, 'event', 'is_native', 'Boolean') = false 
                THEN JSONExtract(fields, 'event', 'protocol_fee', 'UInt64')
            END as fee
        FROM sui.events 
        WHERE timestamp_ms >= ${minTimestamp}
            AND timestamp_ms <= ${maxTimestamp}
            AND (type = '0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::events::Event<0xc27cbe69992b31a811b8d5d34996c4a53b3536f60357b1d50abfa1876458c399::market::FeeEarnedEvent_V2>'
                OR type = '0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::events::Event<0xc8a5487ce3e5b78644f725f83555e1c65c38f0424a72781ed5de4f0369725c79::market::FeeEarnedEvent_V3>')
    ) 
    GROUP BY date, market_id
    ORDER BY date DESC, market_id ASC;`;
    const rows = await (0, sentioClient_js_1.executeSentioQuery)(sql);
    // Convert results to the expected format
    const alphalendMarkets = await (0, getMarkets_js_1.getAllMarkets)();
    const results = [];
    for (const row of rows) {
        const market = alphalendMarkets.find((market) => market.marketId === row.market_id);
        if (!market) {
            throw new Error(`Market not found for id: ${row.market_id}`);
        }
        const coinDecimals = Object.values(alphafi_sdk_1.coinsList).find((coinInfo) => coinInfo.type === market.coinType)?.expo;
        if (!coinDecimals) {
            throw new Error(`Coin decimals not found for coin type: ${market.coinType}`);
        }
        results.push({
            time: (0, dailyRevenue_js_1.getEndOfDayGMT)(Date.parse(dateString)),
            marketCoinType: market.coinType,
            coinAmount: new decimal_js_1.Decimal(row.total_fee).div(10 ** coinDecimals).toString(),
        });
    }
    return results;
}
//# sourceMappingURL=dailyRevenue.js.map